<div class="main no-padding">
  <header-menu></header-menu>

  <div class="center-content internal-registration-establishment fade-in-animation">
    <div class="card area-to-overlay ">
      <div class="card-content">

        <header>
          <h1>Cadastro da Empresa</h1>
        </header>

        <h2>Endereços</h2>

        <div class="form-address-my-profile">

          <accordion [showArrows]="true" [closeOthers]="true">
            <accordion-group class="row form col-xs-12 col-md-7" [isOpened]="company.addresses[i].isOpenAccordion" [heading]="company.addresses[i].nameUnit ? company.addresses[i].nameUnit : item.name" *ngFor="let item of company.addresses; let i = index">
              <accordion-heading>
                <div *ngIf="addressErros[i]?.error" class="pull-left btn-group btn-group-xs">
                  <i aria-hidden="true" class="fa fa-exclamation-triangle"></i>
                </div>
                <div *ngIf="i > 0" class="pull-right btn-group btn-group-xs">
                  <a (click)="removeAddress(i)"><span class="fa fa-trash" tooltip="Excluir" placement="bottom" show-delay="20"></span></a>
                </div>
              </accordion-heading>
              <div class="row form">
                <div class="col-xs-12 col-md-12">
                  <div class="row">
                    <div class="col-xs-7">
                      <div [ngClass]="{'form-group': true, 'has-error': isShowError && addressErros[i]?.nameUnit}">
                        <label class="label-input">{{ 'REGISTRATION_COMPANY.ADDRESS.UNIT_NAME_LABEL' | translate }}*</label>
                        <input [(ngModel)]="company.addresses[i].nameUnit" (ngModelChange)="updateAddressErros($event)" type="text" class="form-control" placeholder="ex.: Unidade Pinheiros">
                      </div>
                    </div>
                    <div class="col-xs-5">
                      <div [ngClass]="{'form-group': true, 'has-error': isShowError && addressErros[i]?.num_employees}">
                        <label class="label-input">{{ 'REGISTRATION_COMPANY.ADDRESS.EMPLOYEES_NUMBER_LABEL' | translate }}</label>
                        <ng-select [(ngModel)]="company.addresses[i].num_employees"
                                    placeholder="Selecione"
                                    [items]="numEmployees"
                                    (ngModelChange)="updateAddressErros($event)">
                        </ng-select>
                      </div>
                    </div>
                  </div>


                  <div class="row">
                    <div class="col-xs-6 col-sm-4">
                      <div [ngClass]="{'form-group': true, 'has-error': isShowError && addressErros[i]?.cep}">
                        <label class="label-input">{{ 'REGISTRATION_COMPANY.ADDRESS.CEP_LABEL' | translate }}*</label>
                        <input [(ngModel)]="company.addresses[i].cep" [disabled]=isLoadingCep [textMask]="{mask: cepMask}" type="text" class="form-control" (ngModelChange)="updateAddressErros()" placeholder="" (blur)="cepChange($event, i)">
                      </div>
                    </div>

                    <div class="col-xs-12 col-sm-8">
                      <div [ngClass]="{'form-group': true, 'has-error': isShowError && addressErros[i]?.neighborhood}">
                        <label class="label-input">{{ 'REGISTRATION_COMPANY.ADDRESS.NEIGHBORHOOD_LABEL' | translate }}*</label>
                        <input type="text" class="form-control" [disabled]=isLoadingCep (ngModelChange)="updateAddressErros()" [(ngModel)]="company.addresses[i].neighborhood">
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-xs-9 col-sm-6">
                      <div [ngClass]="{'form-group': true, 'has-error': isShowError && addressErros[i]?.county}">
                        <label class="label-input">{{ 'REGISTRATION_COMPANY.ADDRESS.COUNTY_LABEL' | translate }}*</label>
                        <input type="text" class="form-control" [disabled]=isLoadingCep (ngModelChange)="updateAddressErros()" [(ngModel)]="company.addresses[i].county">
                      </div>
                    </div>

                    <div class="col-xs-3 col-sm-6">
                      <div [ngClass]="{'form-group': true, 'has-error': isShowError && addressErros[i]?.state}">
                        <label class="label-input">{{ 'REGISTRATION_COMPANY.ADDRESS.STATE_LABEL' | translate }}</label>
                        <ng-select 
                          placeholder="Selecione"
                          [items]="statesList"
                          [active]="company.addresses[i].state"
                        >
                        </ng-select>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-xs-12">
                        <div [ngClass]="{'form-group': true, 'has-error': isShowError && addressErros[i]?.street}">
                        <label class="label-input">{{ 'REGISTRATION_COMPANY.ADDRESS.STREET_LABEL' | translate }}*</label>
                        <input type="text" class="form-control" [disabled]=isLoadingCep (ngModelChange)="updateAddressErros()" [(ngModel)]="company.addresses[i].street">
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-xs-6 col-sm-6">
                        <div [ngClass]="{'form-group': true, 'has-error': isShowError && addressErros[i]?.number}">
                        <label class="label-input">{{ 'REGISTRATION_COMPANY.ADDRESS.NUMBER_LABEL' | translate }}*</label>
                        <input [(ngModel)]="company.addresses[i].number" [disabled]=isLoadingCep (ngModelChange)="updateAddressErros()" type="text" class="form-control" placeholder="">
                      </div>
                    </div>

                    <div class="col-xs-6 col-sm-6">
                      <div [ngClass]="{'form-group': true, 'has-error': isShowError && addressErros[i]?.additional}">
                        <label class="label-input">{{ 'REGISTRATION_COMPANY.ADDRESS.ADDITIONAL_INFO_LABEL' | translate }}</label>
                        <input [(ngModel)]="company.addresses[i].additional" [disabled]=isLoadingCep (ngModelChange)="updateAddressErros()" type="text" class="form-control" placeholder="">
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-xs-8 col-sm-6">
                      <div [ngClass]="{'form-group': true, 'has-error': isShowError && addressErros[i]?.telephone}">
                        <label class="label-input">{{ 'REGISTRATION_COMPANY.ADDRESS.PHONE_NUMBER_LABEL' | translate }}</label>
                        <input [(ngModel)]="company.addresses[i].telephone" [disabled]=isLoadingCep (ngModelChange)="updateAddressErros()" [textMask]="{mask: telephoneMask}" type="text" class="form-control" placeholder="">
                      </div>
                    </div>
                  </div>


                  <div class="row">
                    <div class="col-xs-8 col-sm-6">
                      <div [ngClass]="{'form-group': true}">
                        <div class="buttons-actions-colab-form" *ngIf="!isLoading">
                          <button class="btn btn-orange-contrast" (click)="updateAddress(i)">Salvar</button>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </accordion-group>
          </accordion>
        </div>
        <div class="row">
          <div *ngIf="isShowError" class="col-xs-12 col-md-7">
            <p class="info-error-address">
              <i aria-hidden="true" class="fa fa-exclamation-triangle"></i>
              Um ou mais endereços estão inválidos. Por favor, complete os endereços para poder adicionar.</p>
          </div>
          <div class="col-xs-12 col-md-7">
            <button (click)="addAddress()" class="btn btn-warning navbar-btn" [disabled]="isShowError">
              {{ 'REGISTRATION.ADDRESS.ADD_ADDRESS_LABEL' | translate }}
            </button>
          </div>
        </div>

        <div class="loading-overlay" *ngIf="isLoading">
          <div class="loader-wrp">
            <div class="loader"><span></span><span></span><span></span></div>
            <p> {{ 'LOADING' | translate }}</p>
          </div>
        </div>

      </div>
    </div>
  </div>

</div>
